module.exports = __webpack_public_path__ + "img/samsung-galaxy-grand2.a15440c9.png";